import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ActiveDowntimeDTO, DowntimeRepositoryService } from '../../services/downtime-repository.service';

@Component({
  selector: 'app-downtime-banner',
  templateUrl: './downtime-banner.component.html',
  styleUrls: ['./downtime-banner.component.scss']
})
export class DowntimeBannerComponent implements OnInit, OnDestroy {
  upcomingDowntimes: ActiveDowntimeDTO[] = [];
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(private downtimeService: DowntimeRepositoryService) {}

  ngOnInit(): void {
    this.checkUpcomingDowntime();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  checkUpcomingDowntime(): void {
    this.downtimeService.getUpcoming()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (data) => {
          this.upcomingDowntimes = data.filter(d => !this.isDismissed(d.id));
        },
        (error) => {
          console.error('Error checking upcoming downtime:', error);
        }
      );
  }

  dismiss(id: string): void {
    sessionStorage.setItem(`downtime-dismissed-${id}`, 'true');
    this.upcomingDowntimes = this.upcomingDowntimes.filter(d => d.id !== id);
  }

  private isDismissed(id: string): boolean {
    return sessionStorage.getItem(`downtime-dismissed-${id}`) === 'true';
  }
}
